module.exports = __webpack_public_path__ + "img/retired-2000-museum.a1b2e629.jpg";